// frontend/src/data/questions.js

export const isRelevant = (v) => v === "1" || v === "2";
export const isNo = (v) => v === "4";

/* ================================
   PERSONAL DETAILS
================================ */
export const PERSONAL_DETAILS = [
  { id: "email", type: "email", label: "Email ID", required: true },
  { id: "name", type: "text", label: "Name", required: true },

  {
    id: "qualification",
    type: "choice",
    label: "Highest Qualification",
    required: true, // dropdown (6 options)
    options: [
      { value: "1", label: "MBBS" },
      { value: "2", label: "Diploma" },
      { value: "3", label: "MD/MS" },
      { value: "4", label: "DNB" },
      { value: "5", label: "DM/MCH" },
      { value: "6", label: "Any Other" },
    ],
  },
  {
    id: "qualification_other",
    type: "text",
    label: "Please specify (Any Other) (optional)",
    required: false,
    showIf: (ans) => ans["qualification"] === "6",
  },

  { id: "workplace", type: "text", label: "Current Workplace", required: true },

  {
    id: "beds",
    type: "choice",
    label: "How many beds in your hospital/institution?",
    required: true,
    options: [
      { value: "1", label: "Less than 5" },
      { value: "2", label: "5-10" },
      { value: "3", label: "11-20" },
      { value: "4", label: "21-50" },
      { value: "5", label: "51-100" },
      { value: "6", label: "101-200" },
      { value: "7", label: "201-500" },
      { value: "8", label: "501-1000" },
      { value: "9", label: "More than 1000" },
    ],
  },

  {
    id: "designation",
    type: "choice",
    label: "Designation",
    required: true,
    options: [
      { value: "1", label: "Junior Resident" },
      { value: "2", label: "Senior Resident" },
      { value: "3", label: "Junior Consultant" },
      { value: "4", label: "Senior Consultant" },
      { value: "5", label: "Assistant Professor" },
      { value: "6", label: "Associate Professor" },
      { value: "7", label: "Head of Department" },
      { value: "8", label: "Director / Professor" },
      { value: "9", label: "Dean / Principal" },
    ],
  },

  {
    id: "department",
    type: "choice",
    label: "Department",
    required: true,
    options: [
      { value: "1", label: "Medicine" },
      { value: "2", label: "Surgery" },
      { value: "3", label: "Obs/Gyne" },
      { value: "4", label: "Pediatrics" },
      { value: "5", label: "Orthopedics" },
      { value: "6", label: "Cardiology" },
      { value: "7", label: "Neurology" },
      { value: "8", label: "Nephrology" },
      { value: "9", label: "Gastroenterology" },
      { value: "10", label: "Endocrinology" },
      { value: "11", label: "Dermatology" },
      { value: "12", label: "Psychiatry" },
      { value: "13", label: "ENT" },
      { value: "14", label: "Ophthalmology" },
      { value: "15", label: "Pulmonology / Chest & Lungs Disease" },
      { value: "16", label: "Oncology" },
      { value: "17", label: "Urology" },
      { value: "18", label: "Emergency Department" },
      { value: "19", label: "ICU / Critical Care" },
      { value: "20", label: "Anesthesia" },
      { value: "21", label: "Radiology" },
      { value: "22", label: "Pathology / Laboratory" },
      { value: "23", label: "Physiotherapy" },
      { value: "24", label: "Pharmacy" },
      { value: "25", label: "Blood Bank" },
      { value: "26", label: "Dialysis Unit" },
      { value: "27", label: "Rehabilitation" },
      { value: "28", label: "Nutrition & Dietetics" },
      { value: "29", label: "Palliative Care" },
      { value: "30", label: "Others" },
    ],
  },
  {
    id: "department_other",
    type: "text",
    label: "Please specify (Others) (optional)",
    required: false,
    showIf: (ans) => ans["department"] === "30",
  },
];

/* ================================
   FORM QUESTIONS (Q1–Q10)
================================ */
export const FORM_QUESTIONS = [
  // Q1
  {
    id: "Q1",
    type: "choice",
    label: "Q1. Do you think fluid imbalance is a concerning problem and needs a solution?",
    required: true,
    options: [
      { value: "1", label: "Yes, very much" },
      { value: "2", label: "Yes, to some extent" },
      { value: "3", label: "Rarely" },
      { value: "4", label: "Not at all" },
    ],
  },

  // Q2
  {
    id: "Q2",
    type: "choice",
    label: "Q2. Have you seen a patient die due to fluid imbalance?",
    required: true,
    options: [
      { value: "1", label: "Yes" },
      { value: "2", label: "Possibly" },
      { value: "3", label: "Heard of such cases" },
      { value: "4", label: "No" },
    ],
  },

  // Q3
  {
    id: "Q3",
    type: "choice",
    label: "Q3. Have you seen increased hospital stay due to fluid imbalance?",
    required: true,
    options: [
      { value: "1", label: "Yes, frequently" },
      { value: "2", label: "Yes, sometimes" },
      { value: "3", label: "Rarely" },
      { value: "4", label: "Never" },
    ],
  },

  // Q3.1
  {
    id: "Q3.1",
    type: "choice",
    label: "Q3.1. How do you keep the account of fluid balance in your patients?",
    required: true,
    options: [
      { value: "1", label: "Nursing staff manage it manually" },
      { value: "2", label: "We have an advanced fluid management system" },
      { value: "3", label: "We do not keep much account" },
      { value: "4", label: "Not required in my patients" },
    ],
  },

  // Q3.2 (5 options => dropdown)
  {
    id: "Q3.2",
    type: "choice",
    label: "Q3.2. How do you prescribe fluid therapy in your patients?",
    required: true,
    options: [
      { value: "1", label: "I do it manually for each patient every day" },
      {
        value: "2",
        label:
          "I do it once for each patient during admission and change as per need during visits",
      },
      {
        value: "3",
        label: "I do it once for each patient during admission and rarely change",
      },
      {
        value: "4",
        label:
          "My junior doctors are trained and manage the fluid therapy as per patient need",
      },
      {
        value: "5",
        label:
          "My nursing staff are trained and manage the fluid therapy as per patient need",
      },
    ],
  },

  // Q3.3
  {
    id: "Q3.3",
    type: "choice",
    label:
      "Q3.3. How do you diagnose fluid / electrolyte / acid-base imbalances in your patients?",
    required: true,
    options: [
      { value: "1", label: "We do it manually for each patient every day" },
      { value: "2", label: "My junior doctors inform me about the trends" },
      { value: "3", label: "My nursing staff inform me about the trends" },
      { value: "4", label: "Others" },
    ],
  },
  {
    id: "Q3.3_other",
    type: "text",
    label: "Please specify (Others) (optional)",
    required: false,
    showIf: (ans) => ans["Q3.3"] === "4",
  },

  // Q3.4
  {
    id: "Q3.4",
    type: "choice",
    label: "Q3.4. How satisfied are you with the fluid management system of your hospital?",
    required: true,
    options: [
      { value: "1", label: "Highly satisfied" },
      { value: "2", label: "We manage fairly, but need better support" },
      { value: "3", label: "Highly dissatisfied and urgently need a solution" },
      { value: "4", label: "Others" },
    ],
  },
  {
    id: "Q3.4_other",
    type: "text",
    label: "Please specify (Others) (optional)",
    required: false,
    showIf: (ans) => ans["Q3.4"] === "4",
  },

  /* ================================
     Q4 BRANCH (IV Drip)
  ================================ */
  {
    id: "Q4.1",
    type: "choice",
    label: "Q4.1. Have you heard of any 24-hour IV drip monitoring device?",
    required: true,
    options: [
      { value: "1", label: "Yes, clearly aware" },
      { value: "2", label: "Yes, vaguely aware" },
      { value: "3", label: "Not sure" },
      { value: "4", label: "No" },
    ],
  },
  {
    id: "Q4.1_no_text",
    type: "text",
    label: "If No, please write your comments (optional)",
    required: false,
    showIf: (ans) => isNo(ans["Q4.1"]),
  },
  {
    id: "Q4.2",
    type: "choice",
    label: "Q4.2. Have you used any IV drip monitoring device?",
    required: true,
    showIf: (ans) => isRelevant(ans["Q4.1"]),
    options: [
      { value: "1", label: "Yes, regularly" },
      { value: "2", label: "Yes, once or twice" },
      { value: "3", label: "Only seen/demo" },
      { value: "4", label: "Never" },
    ],
  },
  {
    id: "Q4.3",
    type: "choice",
    label: "Q4.3. Name of device used (IV drip)",
    required: true,
    showIf: (ans) => isRelevant(ans["Q4.1"]),
    options: [
      { value: "1", label: "Name entered" },
      { value: "2", label: "Don’t remember" },
    ],
  },
  {
    id: "Q4.3_text",
    type: "text",
    label: "Please enter device name (optional)",
    required: false,
    autoFocus: true,
    showIf: (ans) => isRelevant(ans["Q4.1"]) && ans["Q4.3"] === "1",
  },
  {
    id: "Q4.4",
    type: "choice",
    label: "Q4.4. Rate your experience with the device (IV drip)",
    required: true,
    showIf: (ans) => isRelevant(ans["Q4.1"]),
    options: [
      { value: "1", label: "Excellent" },
      { value: "2", label: "Good" },
      { value: "3", label: "Average" },
      { value: "4", label: "Poor" },
    ],
  },

  /* ================================
     Q5 BRANCH (Urine Output)
  ================================ */
  {
    id: "Q5.1",
    type: "choice",
    label: "Q5.1. Have you heard of any 24-hour urine output monitoring device?",
    required: true,
    options: [
      { value: "1", label: "Yes, clearly aware" },
      { value: "2", label: "Yes, vaguely aware" },
      { value: "3", label: "Not sure" },
      { value: "4", label: "No" },
    ],
  },
  {
    id: "Q5.1_no_text",
    type: "text",
    label: "If No, please write your comments (optional)",
    required: false,
    showIf: (ans) => isNo(ans["Q5.1"]),
  },
  {
    id: "Q5.2",
    type: "choice",
    label: "Q5.2. Have you used any urine output monitoring device?",
    required: true,
    showIf: (ans) => isRelevant(ans["Q5.1"]),
    options: [
      { value: "1", label: "Yes, regularly" },
      { value: "2", label: "Yes, once or twice" },
      { value: "3", label: "Only seen/demo" },
      { value: "4", label: "Never" },
    ],
  },
  {
    id: "Q5.3",
    type: "choice",
    label: "Q5.3. Name of device used (Urine output)",
    required: true,
    showIf: (ans) => isRelevant(ans["Q5.1"]),
    options: [
      { value: "1", label: "Name entered" },
      { value: "2", label: "Don’t remember" },
    ],
  },
  {
    id: "Q5.3_text",
    type: "text",
    label: "Please enter device name (optional)",
    required: false,
    autoFocus: true,
    showIf: (ans) => isRelevant(ans["Q5.1"]) && ans["Q5.3"] === "1",
  },
  {
    id: "Q5.4",
    type: "choice",
    label: "Q5.4. Rate your experience with the device (Urine output)",
    required: true,
    showIf: (ans) => isRelevant(ans["Q5.1"]),
    options: [
      { value: "1", label: "Excellent" },
      { value: "2", label: "Good" },
      { value: "3", label: "Average" },
      { value: "4", label: "Poor" },
    ],
  },

  /* ================================
     Q6 BRANCH (AI Recommendation)
  ================================ */
  {
    id: "Q6.1",
    type: "choice",
    label: "Q6.1. Have you heard of fluid therapy recommendation AI?",
    required: true,
    options: [
      { value: "1", label: "Yes, clearly aware" },
      { value: "2", label: "Yes, vaguely aware" },
      { value: "3", label: "Not sure" },
      { value: "4", label: "No" },
    ],
  },
  {
    id: "Q6.1_no_text",
    type: "text",
    label: "If No, please write your comments (optional)",
    required: false,
    showIf: (ans) => isNo(ans["Q6.1"]),
  },
  {
    id: "Q6.2",
    type: "choice",
    label: "Q6.2. Have you used any fluid therapy recommendation AI?",
    required: true,
    showIf: (ans) => isRelevant(ans["Q6.1"]),
    options: [
      { value: "1", label: "Yes, regularly" },
      { value: "2", label: "Yes, once or twice" },
      { value: "3", label: "Only seen/demo" },
      { value: "4", label: "Never" },
    ],
  },
  {
    id: "Q6.3",
    type: "choice",
    label: "Q6.3. Name of AI platform used",
    required: true,
    showIf: (ans) => isRelevant(ans["Q6.1"]),
    options: [
      { value: "1", label: "Name entered" },
      { value: "2", label: "Don’t remember" },
    ],
  },
  {
    id: "Q6.3_text",
    type: "text",
    label: "Please enter AI platform name (optional)",
    required: false,
    autoFocus: true,
    showIf: (ans) => isRelevant(ans["Q6.1"]) && ans["Q6.3"] === "1",
  },
  {
    id: "Q6.4",
    type: "choice",
    label: "Q6.4. Rate your experience with the AI recommendation",
    required: true,
    showIf: (ans) => isRelevant(ans["Q6.1"]),
    options: [
      { value: "1", label: "Excellent" },
      { value: "2", label: "Good" },
      { value: "3", label: "Average" },
      { value: "4", label: "Poor" },
    ],
  },

  // Q7
  {
    id: "Q7",
    type: "choice",
    label: "Q7. Do you want to use a 24-hour fluid management system in your hospital?",
    required: true,
    options: [
      { value: "1", label: "Yes, definitely" },
      { value: "2", label: "Yes, would help" },
      { value: "3", label: "Maybe later" },
      { value: "4", label: "No" },
    ],
  },
  {
    id: "Q7_no_text",
    type: "text",
    label: "If No, please write your comments (optional)",
    required: false,
    showIf: (ans) => ans["Q7"] === "4",
  },

  // Q8
  {
    id: "Q8",
    type: "choice",
    label: "Q8. Features you want in solution",
    required: true, // dropdown (5 options)
    options: [
      { value: "1", label: "Real-time intake monitoring" },
      { value: "2", label: "Real-time output monitoring" },
      { value: "3", label: "Alerts for imbalance risk" },
      { value: "4", label: "Automated 24-hour reports" },
      { value: "5", label: "All of the above" },
    ],
  },

  // Q9
  {
    id: "Q9",
    type: "choice",
    label: "Q9. Want all features integrated as one solution?",
    required: true,
    options: [
      { value: "1", label: "Yes, a complete all-in-one system" },
      { value: "2", label: "Prefer a phased / modular integration" },
      { value: "3", label: "Still exploring the best approach" },
      { value: "4", label: "No" },
    ],
  },
  {
    id: "Q9_no_text",
    type: "text",
    label: "If No, please write your comments (optional)",
    required: false,
    showIf: (ans) => ans["Q9"] === "4",
  },

  // Q10
  // {
  //   id: "Q10",
  //   type: "text",
  //   label: "Q10. Any additional suggestions or feedback? (optional)",
  //   required: false,
  // },
];

export const CONGRATS_TEXT =
  "Congratulations. You have got a 6 months free subscription for FLUDEE AI app along with the early bird discount of 50% for FLUDEE 1.0.\n\nYou will be informed about it as soon as it is released in the market.\n\nTerms & conditions.";
